export class SideMenuItems {
    constructor() {
        this.flight = {
            title: 'User Accounts',
            active: true,
            icon: '<i class="fa-duotone fa-users"></i>'
        }
        this.shipment = {
            title: 'Settings',
            active: false,
            icon: '<i class="fa-duotone fa-gears"></i>'
        }

    }
}
